import React, { PureComponent } from 'react';

interface SectionTitleProps {
  title: string;
  showButton?: boolean;
  buttonName?: string;
  onEditClick?: () => void;
  showDeleteButton?: boolean;
  deleteButtonName?: string;
  onDeleteClick?: () => void;
  showCopyButton?: boolean;
  copyButtonName?: string;
  onCopyClick?: () => void;
  showSaveButton?: boolean;
  onSaveClick?: () => void;
  showCancelButton?: boolean;
  onCancelClick?: () => void;
  saveButtonName?: string;
  cancelButtonName?: string;
}

export default class SectionTitle extends PureComponent<SectionTitleProps> {

  onEditClick = () => {
    if (this.props.onEditClick) {
      this.props.onEditClick();
    }
  };

  onDeleteClick = () => {
    if (this.props.onDeleteClick) {
      this.props.onDeleteClick();
    }
  };

  onCopyClick = () => {
    if (this.props.onCopyClick) {
      this.props.onCopyClick();
    }
  };

  onSaveClick = () => {
    if (this.props.onSaveClick) {
      this.props.onSaveClick();
    }
  };

  onCancelClick = () => {
    if (this.props.onCancelClick) {
      this.props.onCancelClick();
    }
  };


  render() {
    const justifyContent: boolean | undefined =
      this.props.showButton || this.props.showSaveButton || (!this.props.showButton && this.props.showDeleteButton);
    return (
      <div
        className={`d-flex row align-items-center ${justifyContent ? 'justify-content-between' : ''}`}>
        <label className="section-header">{this.props.title}</label>
        <div className="horizontal-dividing-line"></div>
        <div className="justify-content-end to-front">
          {
            this.props.showDeleteButton && (
              <button type="button" className="btn btn-danger mr-2"
                      onClick={() => this.onDeleteClick()}>{this.props.deleteButtonName}</button>
            )
          }
          {
            this.props.showCopyButton && (
              <button type="button" className="btn btn-primary mr-2"
                      onClick={() => this.onCopyClick()}>{this.props.copyButtonName}</button>)

          }
          {
            this.props.showCancelButton && (
              <button type="button" className="btn btn-outline-secondary mr-2"
                      onClick={() => this.onCancelClick()}>{this.props.cancelButtonName}</button>
            )
          }
          {
            this.props.showSaveButton && (
              <button type="button" className="btn btn-primary edit-button mr-2"
                      onClick={() => this.onSaveClick()}>{this.props.saveButtonName}</button>
            )
          }
          {
            this.props.showButton && (
              <button type="button" className="btn btn-primary edit-button mr-2"
                      onClick={() => this.onEditClick()}>{this.props.buttonName}</button>
            )
          }
        </div>
      </div>
    );
  }
}
